export const IMAGES = {
  hero: '/images/hero.webp',
  devices: '/images/devices.webp',
  portraits: '/images/portraits.webp',
  printedBooks: '/images/printed-books.webp',
  community: '/images/community.webp',
  whatsNew: {
    cloud: '/images/whats-cloud.webp',
    timeline: '/images/whats-timeline.webp',
    messages: '/images/whats-messages.webp',
    search: '/images/whats-search.webp',
    responsive: '/images/whats-responsive.webp',
    photo: '/images/feature-photo.webp',
    video: '/images/whats-video.webp',
  },
  features: {
    color: '/images/feature-media.webp',
    vault: '/images/whats-cloud.webp',
    sync: '/images/feature-web.webp',
    records: '/images/feature-hints.webp',
    charts: '/images/feature-charts.webp',
    hints: '/images/feature-hints.webp',
    maps: '/images/feature-maps.webp',
    web: '/images/feature-web.webp',
    media: '/images/feature-media.webp',
    photo: '/images/feature-photo.webp',
  },
  products: {
    main: '/images/products/box-main.webp',
    upgrade: '/images/products/box-upgrade.webp',
    companion: '/images/products/box-companion.webp',
    charts: '/images/products/box-charts.webp',
    deluxe: '/images/products/box-deluxe.webp',
  },
};
